<template>
  <div ref="root" :class="$style['adl-chart-line-group']">
    <slot name="tooltipText"></slot>
    <mce-layout
      :plot-width="width"
      :plot-height="height"
      :axis-left-width="axisLeftWidth"
      :axis-right-width="axisRightWidth"
      :class="$style['axis-scroll']"
    >
      <template #legend-top>
        <mce-legend hideTopBorder :horizontal="true">
          <mce-legend-item
            v-for="(d, i) in legendItems"
            :key="i"
            :label="d"
            :key-type="legendKeyType"
            :color="color[i]"
            :class="$style[legendItemsDisable[i]]"
            @click.native="disableLegend(i)"
          ></mce-legend-item>
        </mce-legend>
      </template>
      <template #axis-left>
        <mce-y-axis
          scale-type="linear"
          :labels="{ unit: 'AUD', axis: labelNameY }"
          :domain="domainY"
          :range="rangeY"
          :label-format="FormatCurrency"
          :tickQuantity="tickQuantityY"
        >
          <template v-if="isHideFirstTick" #mce-y-tick-0><span></span></template
        ></mce-y-axis>
      </template>
      <template #axis-bottom>
        <div ref="xAxisParent">
          <mce-x-axis
            scale-type="linear"
            :labels="{ axis: 'Year' }"
            :domain="domainX"
            :range="changeRangeX"
            :showEndTicks="true"
          ></mce-x-axis>
        </div>
      </template>
      <template #default>
        <mce-pointer v-model="mouse" />
        <mce-guidelines
          v-if="mouse && !hideMouseHover"
          :data="[{ x1: mouse.offsetX, x2: mouse.offsetX, y1: 0, y2: height }]"
        />
        <mce-grid
          scale-type-x="linear"
          scale-type-y="linear"
          :domain-y="domainY"
          :domain-x="domainX"
          :range-x="changeRangeX"
          :range-y="rangeY"
          :tickQuantityY="tickQuantityY"
          :outlines="{ top: true, bottom: true }"
        ></mce-grid>
        <template v-if="chartData.length > 0">
          <adl-line-plot
            :key="line.id"
            v-for="(line, index) in chartData"
            :data="line.value"
            :domain-y="domainY"
            :domain-x="domainX"
            :range-x="changeRangeX"
            :range-y="rangeY"
            :color="chartColor[index]"
          ></adl-line-plot>
        </template>
      </template>
    </mce-layout>
  </div>
</template>

<script>
import Vue from "vue";
import MceLayout from "@mce/layout";
import MceYAxis from "@mce/y-axis";
import MceXAxis from "@mce/x-axis";
import McePointer from "@mce/pointer";
import MceHoverFlag from "@mce/hover-flag";
import { MceLegend, MceLegendItem, MceLegendGroup } from "@mce/legend";
import AdlLinePlot from "./adl-line-plot.vue";
import MceGrid from "@mce/grid";
import { format } from "d3-format";
import MceGuidelines from "@mce/guidelines";
import { scaleLinear, scaleBand } from "d3-scale";
import _ from "lodash";
export default Vue.extend({
  name: "AdlChartBarGroup",
  components: {
    MceLayout,
    MceYAxis,
    MceXAxis,
    MceGrid,
    MceLegend,
    MceLegendItem,
    MceLegendGroup,
    AdlLinePlot,
    McePointer,
    MceHoverFlag,
    MceGuidelines,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    color: {
      type: Array,
      default: () => [],
    },

    legendItems: {
      type: Array,
      default: () => [],
    },
    legendKeyType: {
      type: String,
      default: () => "bar",
    },
    hideMouseHover: {
      type: Boolean,
    },
    rangeX: {
      type: Array,
      required: true,
    },
    currencyFormat: {
      type: String,
      required: true,
    },
    rangeY: {
      type: Array,
      required: true,
    },
    domainX: {
      type: Array,
      required: true,
    },

    domainY: {
      type: Array,
      required: true,
    },
    tickQuantityY: {
      type: Number,
      default: 5,
    },
    labelNameY: {
      type: String,
    },
    axisLeftWidth: {
      type: Number,
    },
    axisRightWidth: {
      type: Number,
    },
    height: {
      type: Number,
    },
    width: {
      type: Number,
    },

    toolTipWidth: {
      type: Number,
    },
    isHideFirstTick: {
      type: Boolean,
    },
  },
  data() {
    return {
      mouse: null,
      hoverHeight: 0,
      disableClassName: "disable-legend",
      cursorPointerClassName: "legend-hover",
      currentSelectedLegendIndex: -1,
      paddingLeft: 50,
      focusedData: [],
      legendItemsDisable: [...Array(this.legendItems.length).keys()],
    };
  },
  computed: {
    chartColor() {
      let chartColor = _.cloneDeep(this.color);
      for (let j = this.legendItemsDisable.length - 1; j >= 0; j--) {
        if (this.legendItemsDisable[j] == this.disableClassName) {
          chartColor.splice(j, 1);
        }
      }
      return chartColor;
    },
    chartData() {
      let returnData = _.cloneDeep(this.data);

      for (let j = this.legendItemsDisable.length - 1; j >= 0; j--) {
        if (this.legendItemsDisable[j] == this.disableClassName) {
          returnData.splice(j, 1);
        }
      }

      return returnData;
    },
    changeRangeX() {
      return [0, this.width];
    },

    FormatCurrency: function () {
      return format(this.currencyFormat);
    },
    scaleBandDomain() {
      if (this.data.length > 0)
        return [...Array(this.data[0].value.length).keys()];
      else return [];
    },
    xScale() {
      return scaleLinear().domain(this.domainX).range(this.changeRangeX);
    },
  },
  watch: {
    mouse: {
      async handler() {
        if (this.mouse) {
          let linedata = this.onMouseMove();
          let mouseDataLine = linedata.data._dataIndex;

          this.$emit(
            "setTooltipData",
            mouseDataLine,
            this.legendItemsDisable.filter((sr) => sr != this.disableClassName),
            this.mouse
          );
        } else {
          this.$emit("setTooltipData", null, null, null);
        }
      },
    },
  },

  methods: {
    invertScaleBandX(x) {
      return scaleLinear()
        .domain(this.xScale.range())
        .range(this.xScale.domain())(x);
    },
    onMouseMove() {
      const _dataIndex = this.getXValue();

      return {
        position: this.mouse,
        data: {
          _dataIndex,
        },
      };
    },
    getXValue() {
      return this.invertScaleBandX(this.mouse.offsetX);
    },

    disableLegend(index) {
      let className = this.legendItemsDisable[index];
      if (className == this.disableClassName) {
        this.legendItemsDisable[index] = index;
      } else {
        this.legendItemsDisable[index] = this.disableClassName;
      }
      this.legendItemsDisable = this.legendItemsDisable.concat();
    },
  },
});
</script>

<style lang="scss" module>
.adl-chart-line-group {
  .mce-grid__y-tick {
    stroke-dasharray: 0 !important;
  }
  .mce-axis-x__tick {
    text-align: left !important;
  }
  .mce-grid__y-tick {
    stroke-width: 2 !important;
  }
  .mce-grid__x-stripe:nth-child(odd) {
    opacity: 0.6 !important;
  }
  .legend-hover {
    cursor: pointer;
  }
  .legend-hover {
    cursor: pointer;
  }
  .disable-legend {
    opacity: 0.5;
  }
  li {
    cursor: pointer !important;
  }
}
</style>
